import script from "./EditPersonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPersonComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditPersonComponent.vue?vue&type=style&index=0&id=150cf984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-150cf984"]])

export default __exports__